export class SelectedNotesmodel {
  note: string[]
  createdDate: any
  modifiedDate: any
  userId: any
  centralUserId: any
  financialPeriodsID: any
}
